// -----------------------------------------------------------------------------
// Banner — public entry point.
//
// Dispatches to the correct variant renderer and wraps it in BannerShell.
// All external imports should use this file (or the re-export at
// `@/components/renderings/Banner`).
//
// Re-exports every type so consumers keep a single import path.
// -----------------------------------------------------------------------------

export { BannerShell } from "./BannerShell";
export { HeroBanner } from "./HeroBanner";
export { StandardBanner } from "./StandardBanner";
export * from "./types";

import { BannerShell } from "./BannerShell";
import { HeroBanner } from "./HeroBanner";
import { StandardBanner } from "./StandardBanner";
import type { BannerProps } from "./types";

export function Banner(props: BannerProps) {
  const Variant = props.variant === "standard" ? StandardBanner : HeroBanner;
  return (
    <BannerShell
      colorScheme={props.colorScheme}
      height={props.height}
      bottomCurve={props.bottomCurve}
      decoration={props.decoration}
      backgroundImage={props.backgroundImage}
    >
      <Variant {...props} />
    </BannerShell>
  );
}

export default Banner;
